<template>
    <section class="content">
        <div class="container-fluid">
            <div class="block-header">
                <h2>{{ nama }}</h2>
            </div>
            <div class="row clearfix">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card">
                        <div class="header">
                            <h2>
                                {{ id_unduh != null ? 'Edit' : 'Tambah' }} {{ nama }}
                            </h2>
                        </div>
                        <div class="body">
                            <form class="form-horizontal" v-on:submit.prevent="save">
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="jenis">Jenis</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <select v-if="link == 'laporan'" id="jenis" class="form-control" v-model="content.tipe">
                                                <option value="">[ Pilih Jenis Laporan ]</option>
                                                <option value="1">Laporan Keuangan</option>
                                                <option value="2">Laporan Pengawasan</option>
                                                <option value="10">Survey</option>
                                            </select>
                                            <select v-if="link == 'formulir'" id="jenis" class="form-control" v-model="content.tipe">
                                                <option value="">[ Pilih Jenis Formulir ]</option>
                                                <option value="3">Formulir Kepersertaan</option>
                                                <option value="4">Formulir Her Registrasi</option>
                                                <option value="5">Formulir Pensiun Normal</option>
                                                <option value="6">Formulir Pensiun Dipercepat</option>
                                                <option value="7">Formulir Pensiun Ditunda</option>
                                                <option value="8">Formulir Pensiun Cacat</option>
                                                <option value="9">Formulir Pensiun Meninggal</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                  <div class="row clearfix" v-if="link === 'formulir'">
                                      <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="bermaterai">Bermaterai</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <select v-show="link == 'formulir'" id="bermaterai" class="form-control" v-model="content.bermaterai">
                                                <option :value="false">[ apakah bermaterai ]</option>
                                                <option :value=true>Bermaterai</option>
                                                <option :value=false>Tidak Bermaterai</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="judul">Judul</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <form-line id="judul" type="text" v-model="content.judul"></form-line>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="tahun">Tahun</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <form-line id="tahun" type="number" v-model="content.tahun"></form-line>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="icon">File</label>
                                    </div>
                                    <div class="col-lg-2" v-if="content.file != null">
                                        <a class="btn btn-sm btn-info" target="_blank" v-bind:href="content.file"><i class="fa fa-paperclip"></i> File</a>
                                    </div>
                                    <div class="col-lg-8 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <input id="icon" class="form-control" type="file" name="icon" @change="handleFile($event)" />
                                        </div>
                                    </div>
                                </div>
                                <div class='row clearfix' v-if='id_unduh != null && link === "laporan"'>
                                  <div
                                    class='col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label'
                                  >
                                    <label for='thumbnailFormulir'>thumbnailFormulir</label>
                                  </div>
                                  <div class='col-lg-10 col-md-10 col-sm-8 col-xs-7'>
                                    <div class='form-group'>
                                      <vue-dropzone
                                        v-if="id_unduh"
                                        ref="thumbnailFormulir"
                                        id="thumbnailFormulir"
                                        :destroyDropzone="false"
                                        :options="dropzoneOptionsFormulir"
                                        @vdropzone-removed-file="vremoved"
                                        @vdropzone-success="onUploadSuccess"
                                      ></vue-dropzone>
                                    </div>
                                  </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="tags">Tags</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <form-line type="text" id="tags" v-model="content.tags" :config="config"></form-line>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                        <button v-if="id_unduh != null" @click="update" type="button" class="btn btn-warning waves-effect waves-button" v-waves.button><i class="material-icons">save</i> Edit</button>
                                        <button v-else @click="save" type="button" class="btn btn-primary waves-effect waves-button" v-waves.button><i class="material-icons">save</i> Simpan</button>
                                        <button @click="$router.go(-1)" type="button" class="btn btn-danger waves-effect waves-button" v-waves.button><i class="material-icons">cancel</i> Batal</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
/* eslint-disable */

  import Ckeditor from 'vue-ckeditor2'
  import FormLine from '@/components/FormLine.vue'
  import api from '@/helper/api'
  import vue2Dropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.css'

  export default {
    components: {
      FormLine,
      Ckeditor,
      vueDropzone: vue2Dropzone
    },
    name: 'ListNarasumber',
    data: function () {
      return {
        date: {
          dateFormat: 'Y-m-d',
          allowInput: true
        },
        config: {
          toolbar: [
            { name: 'stuff', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
            { name: 'morestuff', items: ['NumberedList', 'BulletedList'] },

            { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Superscript', 'Subscript'] },
            { name: 'colors', items: ['TextColor'] },
            { name: 'paragraph2', items: ['JustifyLeft', 'JustiftyCenter', 'JustifyRight', 'Outdent', 'Indent'] },
            '/',
            { name: 'document', items: ['Source'] }
          ],
          height: 300
        },
        content: {
          judul: '',
          tipe: '',
          tahun: '',
          tags: '',
          thumbnail:'',
          bermaterai: false,
        },
        file: '',
        id_unduh: '',
        nama: '',
        tipe: '',
        link: '',
        thumbnailUrl:''
      }
    },
  computed: {
  dropzoneOptionsFormulir () {
    if(this.id_unduh != null) {
      return {
        url: api.defaults.baseURL + '/upload_image_dropzoneUnduhFormulir?id=' + this.id_unduh,
        thumbnailWidth: 150,
        addRemoveLinks: true,
        maxFiles: 1,
        maxFilesize: 2,
        dictRemoveFileConfirmation: 'Anda yakin ingin menghapus file ini?',
        headers: { Authorization: 'Bearer ' + localStorage.getItem('_token') },
        params: { id_unduh: this.id_unduh }
      }
    }
  }
    },
    methods: {
      save () {
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        var form = new FormData()
        form.append('file', this.file)
        form.append('json', JSON.stringify(this.content))
        api.post('/unduh', form).then((result) => {
          if (result.data.code === 200) {
            if (this.link === 'laporan') {
              this.$router.replace('/main/unduh/laporan/' + result.data.object.id_unduh)
            } else if (this.link === 'formulir') {
              this.$router.replace('/main/unduh/formulir/')
            }
            this.$toastr.s('Tambah data berhasil')
          } else {
            var msg = 'Tambah data gagal'
            if (result.data.message !== '') msg = result.data.message
            this.$toastr.e(msg)
          }
        }).catch(e => {
          var msg = 'Terjadi kesalahan pada server, mohon ulangi'
          if (e.response.data.message) msg = e.response.data.message
          this.$toastr.e(msg)
        })
      },
      update () {
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        var form = new FormData()
        form.append('file', this.file)
        form.append('json', JSON.stringify(this.content))
        console.log('ini form', form)
        console.log('ini form content', this.content)
        api.post('/unduh/' + this.id_unduh, form).then((result) => {
          if (result.data.code === 200) {
            this.$router.replace('/main/unduh/' + this.link)
            this.$toastr.s('Ubah data berhasil')
          }
        }).catch((ex) => {
          var msg = 'Terjadi kesalahan pada server, mohon ulangi'
          if (ex.response.data.message) msg = ex.response.data.message
          this.$toastr.e(msg)
        })
      },
      getDetail () {
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.get('/unduh/' + this.id_unduh).then((result) => {
          this.content = result.data
          if (this.content.thumbnail) {
          const mockFile = {
          name: 'Thumbnail Laporan',
          size: 123456, 
          type: 'image/jpeg' 
        }
      this.$refs.thumbnailFormulir.manuallyAddFile(mockFile, this.content.thumbnail)
    }
          console.log("ini hasil datanya: " + JSON.stringify(this.content, null, 2))

        }).catch((ex) => {
          this.$toastr.e('Terjadi kesalahan pada server, mohon ulangi')
        })
      },
      onUploadSuccess (file, response) {
        // response.url berasal dari Spring Boot
        this.thumbnailUrl = response.url
        this.content.thumbnail = response.fileName
        console.log('Thumbnail uploaded to:', this.content.thumbnailUrl)
      },
      vremoved (file, xhr, error) {
      console.log("ini filenya", file)
      this.delete(file.name.id)
      },
      handleFile (file) {
        this.file = file.target.files[0]
      },
      checkRoute (route) {
        console.log(route.name)
        if (route.name === 'TambahLaporan' || route.name === 'EditLaporan') {
          this.link = 'laporan'
          this.nama = 'Laporan'
        }
        if (route.name === 'TambahFormulir' || route.name === 'EditFormulir') {
          this.link = 'formulir'
          this.nama = 'Formulir'
        }
      }
    },
    mounted () {
      this.checkRoute(this.$route)
      this.id_unduh = this.$route.params.id
      if (this.id_unduh != null) {
        this.getDetail()
      }
    },
    watch: {
  '$route' (to, from) {
    this.checkRoute(to)
    this.id_unduh = to.params.id
    if (this.id_unduh) {
      this.getDetail()
    }
    }
  }
  }
</script>


// WEBPACK FOOTER //
// src/view/Unduh/Unduh/FormUnduh.vue?257146d2